(ns hai.interfaces.chat.routes
  (:require [hai.ui.components :as c]
            [hai.web-app.layout :as layout]))

(defn interfaces-chat-page
  [_]
  [layout/page
   [layout/title-bar
    [c/Heading "Your knowledge + you AI = one simple chat"]]
   [:div [:a {:href "https://assistant.thehumbleai.com"
              :target "_blank"} "https://assistant.thehumbleai.com"]]])
